<abs-tooltip class="abs-tooltip">
  <a #messageTooltip class="icon-tooltip tooltip-element" tabindex="0" role="button"
    [attr.data-placement]="dataPlacement" (click)="tooltipSonarFix('MessageTooltip')"
    (keydown)="tooltipSonarFix('MessageTooltip')" aria-label="Help" aria-expanded="false">
    <span class="arrow"></span>
  </a>
  <span class="abs-tooltip-wrapper">
    <span class="abs-tooltip-size-control">
      <span [attr.id]="id" role="tooltip" [attr.aria-live]="'polite'" [attr.aria-hidden]="'true'" class="abs-helpertext"
        tabindex="-1">
        <span class="abs-popover-content">
          <span>{{message}}</span>
        </span>
      </span>
    </span>
  </span>
</abs-tooltip>